export { default as FloatingDismissIcon } from './ic_dismiss_16x16.svg';
export { default as FloatingGreenIcon } from './icon_floating_green.svg';
export { default as FloatingMembershipIcon } from './icon_floating_membership.svg';
export { default as FloatingOrangeIcon } from './icon_floating_orange.svg';
export { default as FloatingSolidIcon } from './icon_floating_solid.svg';
export { default as FloatingStrokeIcon } from './icon_floating_stroke.svg';
export { default as FloatingTransparantIcon } from './icon_floating_transparant.svg';
